var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [_c("AdminNavigationV2", { attrs: { tid: _vm.tid } })],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-5 col-sm-6 text-right" }, [
          _c(
            "a",
            {
              staticClass: "btn btn-success text-white",
              staticStyle: { padding: "0.7em 2em" },
              attrs: {
                href: `/#/admin/organizations/workspaces/create/${_vm.tid}`,
                role: "button",
              },
            },
            [
              _c("i", {
                staticClass: "fa fa-plus",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Add workspace")]),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _vm.workspaces.length
        ? _c("table", { staticClass: "table table-striped" }, [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.workspaces, function (w, i) {
                return _c("tr", { key: w.WorkspaceId }, [
                  _c("th", { attrs: { scope: "row" } }, [
                    _vm._v(_vm._s(i + 1)),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: `/#/admin/organizations/workspaces/manage/${w.WorkspaceId}`,
                        },
                      },
                      [_vm._v(_vm._s(w.Name))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(w.Description))]),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: w.StartupUrl
                            ? `/#${w.StartupUrl}${w.WorkspaceId}`
                            : `/#/projects/${w.WorkspaceId}`,
                          target: "_blank",
                        },
                      },
                      [_vm._v("Open")]
                    ),
                  ]),
                ])
              }),
              0
            ),
          ])
        : _c("h4", [_vm._v("No workspaces")]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-lg-7" }, [
      _c(
        "h1",
        {
          staticStyle: {
            "font-size": "2em",
            "font-weight": "300",
            color: "#33475b",
          },
        },
        [_vm._v("Workspaces")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c(
          "th",
          { staticStyle: { "border-top": "none" }, attrs: { scope: "col" } },
          [_vm._v("#")]
        ),
        _vm._v(" "),
        _c(
          "th",
          { staticStyle: { "border-top": "none" }, attrs: { scope: "col" } },
          [_vm._v("Name")]
        ),
        _vm._v(" "),
        _c(
          "th",
          { staticStyle: { "border-top": "none" }, attrs: { scope: "col" } },
          [_vm._v("Description")]
        ),
        _vm._v(" "),
        _c("th", {
          staticStyle: { "border-top": "none" },
          attrs: { scope: "col" },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }